module.exports = __webpack_public_path__ + "static/media/calendar-white.430970ee.svg";